export default function responsiveValues (width) {
    let object
    //Mobiles
    if (width < 720) {
        object = {
            //INITIAL SETS
            objPosX: 0.8,
            objPosY: -10,
            objPosZ: -8,
            
            objRotX: Math.PI/2,
            objRotY: -Math.PI/5,
            objRotZ: -Math.PI/2,
            //Entry Animation
            entryObjPosY: 0,

            //Components Part
            ComponentsRotY: -Math.PI,
            ComponentsPosX: 0,
            ComponentPosZ: -15,
            CompoentsCameraPosY: 0,

            CameraPosY: -11,
        }
    }
    //Tablets
    else if (width >= 720 && width < 1024) {
        object = {
            objPosX: 0.5,
            objPosY: -10,
            objPosZ: -4,

            objRotX: Math.PI/2,
            objRotY: -Math.PI/5,
            objRotZ: -Math.PI/2,

            entryObjPosY: 0,

            ComponentsRotY: -Math.PI,
            ComponentsRotZ: Math.PI/2,
            ComponentsPosX: 0,
            ComponentPosZ: -12,
            CompoentsCameraPosY: 0,

            CameraPosY: -10,
        }
    }
    // Desktops
    else if (width >= 1024){
        object = {
            objPosX: 0.1,
            objPosY: -10,
            objPosZ: -3,

            objRotX: Math.PI/2,
            objRotY: -Math.PI/2,
            objRotZ: Math.PI/2,


            entryObjPosY: -0.8,

            // ComponentsRotX: Math.PI/2,
            ComponentsRotY: -Math.PI/2,
            // ComponentsRotZ: Math.PI/2,

            ComponentsPosX: 0,
            ComponentPosZ: -6,

            CompoentsCameraPosY: 0,

            CameraPosY: -6.5,
        }
    }

    return object
}